module.exports = __webpack_public_path__ + "static/media/craftCat2.60c422fd.jpg";